/* GENERATED FILE — DO NOT EDIT. Emitted by tools/engine-tests/RequiredFieldsRuler.swift (RequiredFieldsEmit).
 * Regenerate:  KATA_EMIT_REQUIRED_FIELDS=1 ./tools/engine-tests/run.sh
 * Source:      Exercise.CodingKeys + Exercise.init(from:) (HybridTrainer/Models/Exercise.swift), the ten core readers,
 *              web/src/lib/coachExercise.ts rowFromDraft, CoachLibraryService.ExerciseWrite + CoachExerciseFormView.
 * Gate:        f15-1-the-required-fields-are-a-gate regenerates this in memory every run; any difference is red.
 * Design:      docs/F15-COACH-ENGINE-DESIGN.md §3 (the list, MEASURED 2026-10-30), §7 step 1 (this gate).
 * Rule:        a field is ABSENT when the raw row has no value for it (missing or null), plus [] / "" where the class says
 *              nullOrEmpty; `mobility_drill_kind` is asked of mobility rows only. A DECODE SUBSTITUTE IS NOT AN ANSWER:
 *              `category` decodes "Strength" and `injury_contraindications` decode {} when missing — both WRONG BY DEFAULT —
 *              so readiness is judged on the RAW row, never on the decoded Exercise.
 * The phone's twin is HybridTrainer/Models/EngineRequiredFields.generated.swift — the same rows, the same rule. */

export type EngineFieldNeed = "required" | "requiredForMobility" | "identity" | "fetchGate" | "optional" | "displayOnly";
export type EngineFieldAbsence = "nullOnly" | "nullOrEmpty" | "mobilityOnly" | "never";
export type EngineField = {
  column: string;
  property: string;
  need: EngineFieldNeed;
  absence: EngineFieldAbsence;
  /** The `coach_exercises` column that answers it, or null — the coach-side gap. */
  coachColumn: string | null;
  /** The reader that makes it required. */
  requiredBy: string | null;
  /** What the phone's decoder substitutes when the key is missing (`nil`, a literal, or `THROWS`). */
  decodeSubstitute: string;
  wrongByDefault: boolean;
  /** null = no coach column; else which builders collect it today (`web`, `phone`). */
  collectedBy: readonly string[] | null;
  readBy: readonly string[];
};

export const ENGINE_FIELDS: readonly EngineField[] = [
  { column: "id", property: "id", need: "identity", absence: "nullOrEmpty",
    coachColumn: "id", requiredBy: "HybridTrainer/Services/AI/ExerciseSelector.swift",
    decodeSubstitute: "THROWS", wrongByDefault: false,
    collectedBy: null, readBy: ["ExerciseFilterService.swift", "ExerciseSelector.swift", "ProgramAssembler.swift", "ProgramLinterData.swift", "ProgramValidator.swift", "ExerciseMuscleSatellite.swift", "EngineSessionMainBlock.swift"] },
  { column: "name", property: "name", need: "identity", absence: "nullOrEmpty",
    coachColumn: "name", requiredBy: "HybridTrainer/Services/AI/ExerciseSelector.swift",
    decodeSubstitute: "THROWS", wrongByDefault: false,
    collectedBy: ["web", "phone"], readBy: ["ExerciseFilterService.swift", "ExerciseSelector.swift", "ProgramAssembler.swift", "ProgramLinterData.swift", "ProgramValidator.swift", "EngineSessionMainBlock.swift", "JointActionCoverage.swift"] },
  { column: "description", property: "description", need: "displayOnly", absence: "never",
    coachColumn: null, requiredBy: null,
    decodeSubstitute: "\"\"", wrongByDefault: false,
    collectedBy: null, readBy: [] },
  { column: "category", property: "category", need: "required", absence: "nullOnly",
    coachColumn: "category", requiredBy: "HybridTrainer/Services/AI/ProgramValidator.swift",
    decodeSubstitute: "\"Strength\"", wrongByDefault: true,
    collectedBy: ["web", "phone"], readBy: ["ProgramValidator.swift"] },
  { column: "muscle_groups", property: "muscleGroups", need: "displayOnly", absence: "never",
    coachColumn: null, requiredBy: null,
    decodeSubstitute: "[]", wrongByDefault: false,
    collectedBy: null, readBy: [] },
  { column: "equipment", property: "equipment", need: "required", absence: "nullOnly",
    coachColumn: "equipment", requiredBy: "HybridTrainer/Services/AI/ExerciseFilterService.swift",
    decodeSubstitute: "[]", wrongByDefault: false,
    collectedBy: ["web", "phone"], readBy: ["ExerciseFilterService.swift", "ProgramValidator.swift"] },
  { column: "instructions", property: "instructions", need: "displayOnly", absence: "never",
    coachColumn: null, requiredBy: null,
    decodeSubstitute: "[]", wrongByDefault: false,
    collectedBy: null, readBy: [] },
  { column: "tips", property: "tips", need: "displayOnly", absence: "never",
    coachColumn: null, requiredBy: null,
    decodeSubstitute: "[]", wrongByDefault: false,
    collectedBy: null, readBy: [] },
  { column: "contraindications", property: "contraindications", need: "displayOnly", absence: "never",
    coachColumn: null, requiredBy: null,
    decodeSubstitute: "[]", wrongByDefault: false,
    collectedBy: null, readBy: [] },
  { column: "demo_video_url", property: "demoVideoURL", need: "displayOnly", absence: "never",
    coachColumn: null, requiredBy: null,
    decodeSubstitute: "nil", wrongByDefault: false,
    collectedBy: null, readBy: [] },
  { column: "thumbnail_url", property: "thumbnailURL", need: "displayOnly", absence: "never",
    coachColumn: null, requiredBy: null,
    decodeSubstitute: "nil", wrongByDefault: false,
    collectedBy: null, readBy: [] },
  { column: "tags", property: "tags", need: "optional", absence: "never",
    coachColumn: null, requiredBy: null,
    decodeSubstitute: "[]", wrongByDefault: false,
    collectedBy: null, readBy: ["ProgramValidator.swift"] },
  { column: "is_published", property: "isPublished", need: "fetchGate", absence: "never",
    coachColumn: null, requiredBy: "HybridTrainer/Services/AI/ExerciseFilterService.swift",
    decodeSubstitute: "true", wrongByDefault: false,
    collectedBy: null, readBy: ["ExerciseFilterService.swift", "ExerciseMuscleSatellite.swift"] },
  { column: "created_by", property: "createdBy", need: "displayOnly", absence: "never",
    coachColumn: null, requiredBy: null,
    decodeSubstitute: "nil", wrongByDefault: false,
    collectedBy: null, readBy: [] },
  { column: "created_at", property: "createdAt", need: "displayOnly", absence: "never",
    coachColumn: null, requiredBy: null,
    decodeSubstitute: "nil", wrongByDefault: false,
    collectedBy: null, readBy: [] },
  { column: "updated_at", property: "updatedAt", need: "displayOnly", absence: "never",
    coachColumn: null, requiredBy: null,
    decodeSubstitute: "nil", wrongByDefault: false,
    collectedBy: null, readBy: [] },
  { column: "movement_pattern", property: "movementPattern", need: "required", absence: "nullOnly",
    coachColumn: "movement_pattern", requiredBy: "HybridTrainer/Services/AI/ProgramValidator.swift",
    decodeSubstitute: "nil", wrongByDefault: false,
    collectedBy: ["web", "phone"], readBy: ["ExerciseFilterService.swift", "ProgramValidator.swift"] },
  { column: "exercise_type", property: "exerciseType", need: "required", absence: "nullOnly",
    coachColumn: null, requiredBy: "HybridTrainer/Services/AI/ProgramValidator.swift",
    decodeSubstitute: "nil", wrongByDefault: false,
    collectedBy: null, readBy: ["ExerciseFilterService.swift", "ProgramValidator.swift"] },
  { column: "loading_type", property: "loadingType", need: "displayOnly", absence: "never",
    coachColumn: null, requiredBy: null,
    decodeSubstitute: "nil", wrongByDefault: false,
    collectedBy: null, readBy: [] },
  { column: "movement_plane", property: "movementPlane", need: "displayOnly", absence: "never",
    coachColumn: null, requiredBy: null,
    decodeSubstitute: "nil", wrongByDefault: false,
    collectedBy: null, readBy: [] },
  { column: "difficulty_level", property: "difficultyLevel", need: "required", absence: "nullOnly",
    coachColumn: "difficulty", requiredBy: "HybridTrainer/Services/AI/ExerciseFilterService.swift",
    decodeSubstitute: "nil", wrongByDefault: false,
    collectedBy: ["web", "phone"], readBy: ["ExerciseFilterService.swift", "ProgramAssembler.swift", "ProgramLinterData.swift", "ProgramValidator.swift", "EngineSessionMainBlock.swift"] },
  { column: "primary_muscles", property: "primaryMuscles", need: "required", absence: "nullOrEmpty",
    coachColumn: "primary_muscles", requiredBy: "HybridTrainer/Services/AI/ExerciseMuscleSatellite.swift",
    decodeSubstitute: "[]", wrongByDefault: false,
    collectedBy: ["web", "phone"], readBy: ["ExerciseFilterService.swift", "ExerciseMuscleSatellite.swift", "JointActionCoverage.swift"] },
  { column: "secondary_muscles", property: "secondaryMuscles", need: "optional", absence: "never",
    coachColumn: null, requiredBy: null,
    decodeSubstitute: "[]", wrongByDefault: false,
    collectedBy: null, readBy: ["ExerciseMuscleSatellite.swift"] },
  { column: "joints_involved", property: "jointsInvolved", need: "displayOnly", absence: "never",
    coachColumn: null, requiredBy: null,
    decodeSubstitute: "[]", wrongByDefault: false,
    collectedBy: null, readBy: [] },
  { column: "default_tempo", property: "defaultTempo", need: "optional", absence: "never",
    coachColumn: null, requiredBy: null,
    decodeSubstitute: "nil", wrongByDefault: false,
    collectedBy: null, readBy: [] },
  { column: "default_seconds_per_rep", property: "defaultSecondsPerRep", need: "optional", absence: "never",
    coachColumn: null, requiredBy: null,
    decodeSubstitute: "nil", wrongByDefault: false,
    collectedBy: null, readBy: ["ProgramValidator.swift"] },
  { column: "typical_rep_range_min", property: "typicalRepRangeMin", need: "optional", absence: "never",
    coachColumn: null, requiredBy: null,
    decodeSubstitute: "nil", wrongByDefault: false,
    collectedBy: null, readBy: ["EngineSessionMobilityBlock.swift"] },
  { column: "typical_rep_range_max", property: "typicalRepRangeMax", need: "optional", absence: "never",
    coachColumn: null, requiredBy: null,
    decodeSubstitute: "nil", wrongByDefault: false,
    collectedBy: null, readBy: ["EngineSessionMobilityBlock.swift"] },
  { column: "is_hold", property: "isHold", need: "required", absence: "nullOnly",
    coachColumn: "is_hold", requiredBy: "HybridTrainer/Services/AI/ProgramAssembler.swift",
    decodeSubstitute: "false", wrongByDefault: false,
    collectedBy: ["phone"], readBy: ["ExerciseFilterService.swift", "ProgramAssembler.swift", "ProgramValidator.swift", "EngineSessionMainBlock.swift"] },
  { column: "is_straight_arm", property: "isStraightArm", need: "optional", absence: "never",
    coachColumn: null, requiredBy: null,
    decodeSubstitute: "nil", wrongByDefault: false,
    collectedBy: null, readBy: [] },
  { column: "is_unilateral", property: "isUnilateral", need: "optional", absence: "never",
    coachColumn: null, requiredBy: null,
    decodeSubstitute: "nil", wrongByDefault: false,
    collectedBy: null, readBy: ["ProgramValidator.swift"] },
  { column: "typical_hold_seconds_min", property: "typicalHoldSecondsMin", need: "optional", absence: "never",
    coachColumn: null, requiredBy: null,
    decodeSubstitute: "nil", wrongByDefault: false,
    collectedBy: null, readBy: [] },
  { column: "typical_hold_seconds_max", property: "typicalHoldSecondsMax", need: "optional", absence: "never",
    coachColumn: null, requiredBy: null,
    decodeSubstitute: "nil", wrongByDefault: false,
    collectedBy: null, readBy: [] },
  { column: "loads_grip", property: "loadsGrip", need: "optional", absence: "never",
    coachColumn: null, requiredBy: null,
    decodeSubstitute: "nil", wrongByDefault: false,
    collectedBy: null, readBy: [] },
  { column: "loads_pronation_supination", property: "loadsPronationSupination", need: "optional", absence: "never",
    coachColumn: null, requiredBy: null,
    decodeSubstitute: "nil", wrongByDefault: false,
    collectedBy: null, readBy: [] },
  { column: "axial_load", property: "axialLoad", need: "optional", absence: "never",
    coachColumn: null, requiredBy: null,
    decodeSubstitute: "nil", wrongByDefault: false,
    collectedBy: null, readBy: [] },
  { column: "stability_demand", property: "stabilityDemand", need: "optional", absence: "never",
    coachColumn: null, requiredBy: null,
    decodeSubstitute: "nil", wrongByDefault: false,
    collectedBy: null, readBy: [] },
  { column: "systemic_cost", property: "systemicCost", need: "optional", absence: "never",
    coachColumn: null, requiredBy: null,
    decodeSubstitute: "nil", wrongByDefault: false,
    collectedBy: null, readBy: [] },
  { column: "connective_tissue_cost", property: "connectiveTissueCost", need: "optional", absence: "never",
    coachColumn: null, requiredBy: null,
    decodeSubstitute: "nil", wrongByDefault: false,
    collectedBy: null, readBy: [] },
  { column: "movement_pattern_id", property: "movementPatternId", need: "required", absence: "nullOnly",
    coachColumn: null, requiredBy: "HybridTrainer/Services/AI/ProgramLinterData.swift",
    decodeSubstitute: "nil", wrongByDefault: false,
    collectedBy: null, readBy: ["ProgramLinterData.swift", "ExerciseMuscleSatellite.swift"] },
  { column: "prerequisite_ids", property: "prerequisiteIds", need: "optional", absence: "never",
    coachColumn: null, requiredBy: null,
    decodeSubstitute: "[]", wrongByDefault: false,
    collectedBy: null, readBy: ["ExerciseFilterService.swift", "ProgramAssembler.swift", "ProgramLinterData.swift", "ProgramValidator.swift"] },
  { column: "progression_ids", property: "progressionIds", need: "optional", absence: "never",
    coachColumn: null, requiredBy: null,
    decodeSubstitute: "[]", wrongByDefault: false,
    collectedBy: null, readBy: ["ExerciseFilterService.swift", "ProgramLinterData.swift"] },
  { column: "regression_ids", property: "regressionIds", need: "optional", absence: "never",
    coachColumn: null, requiredBy: null,
    decodeSubstitute: "[]", wrongByDefault: false,
    collectedBy: null, readBy: ["ProgramAssembler.swift", "ProgramLinterData.swift"] },
  { column: "alternative_ids", property: "alternativeIds", need: "displayOnly", absence: "never",
    coachColumn: null, requiredBy: null,
    decodeSubstitute: "[]", wrongByDefault: false,
    collectedBy: null, readBy: [] },
  { column: "injury_contraindications", property: "injuryContraindications", need: "required", absence: "nullOnly",
    coachColumn: null, requiredBy: "HybridTrainer/Services/InjuryMatchingService.swift",
    decodeSubstitute: "[:]", wrongByDefault: true,
    collectedBy: null, readBy: ["InjuryMatchingService.swift"] },
  { column: "injury_cautions", property: "injuryCautions", need: "optional", absence: "never",
    coachColumn: null, requiredBy: null,
    decodeSubstitute: "[:]", wrongByDefault: false,
    collectedBy: null, readBy: ["InjuryMatchingService.swift"] },
  { column: "injury_therapeutic", property: "injuryTherapeutic", need: "optional", absence: "never",
    coachColumn: null, requiredBy: null,
    decodeSubstitute: "[]", wrongByDefault: false,
    collectedBy: null, readBy: ["ExerciseFilterService.swift"] },
  { column: "form_cues", property: "formCues", need: "displayOnly", absence: "never",
    coachColumn: null, requiredBy: null,
    decodeSubstitute: "[]", wrongByDefault: false,
    collectedBy: null, readBy: [] },
  { column: "common_mistakes", property: "commonMistakes", need: "displayOnly", absence: "never",
    coachColumn: null, requiredBy: null,
    decodeSubstitute: "[]", wrongByDefault: false,
    collectedBy: null, readBy: [] },
  { column: "coach_notes", property: "coachNotes", need: "displayOnly", absence: "never",
    coachColumn: null, requiredBy: null,
    decodeSubstitute: "nil", wrongByDefault: false,
    collectedBy: null, readBy: [] },
  { column: "goals_served", property: "goalsServed", need: "required", absence: "nullOrEmpty",
    coachColumn: null, requiredBy: "HybridTrainer/Services/AI/ExerciseFilterService.swift",
    decodeSubstitute: "[]", wrongByDefault: false,
    collectedBy: null, readBy: ["ExerciseFilterService.swift", "ProgramValidator.swift"] },
  { column: "identity_aliases", property: "identityAliases", need: "optional", absence: "never",
    coachColumn: null, requiredBy: null,
    decodeSubstitute: "[]", wrongByDefault: false,
    collectedBy: null, readBy: ["ExerciseSelector.swift", "ProgramValidator.swift"] },
  { column: "mobility_drill_kind", property: "mobilityDrillKind", need: "requiredForMobility", absence: "mobilityOnly",
    coachColumn: null, requiredBy: "HybridTrainer/Services/AI/EngineSessionMobilityBlock.swift",
    decodeSubstitute: "nil", wrongByDefault: false,
    collectedBy: null, readBy: ["EngineSessionMobilityBlock.swift"] },
  { column: "avg_actual_seconds_per_rep", property: "avgActualSecondsPerRep", need: "displayOnly", absence: "never",
    coachColumn: null, requiredBy: null,
    decodeSubstitute: "nil", wrongByDefault: false,
    collectedBy: null, readBy: [] },
  { column: "avg_user_rpe", property: "avgUserRpe", need: "displayOnly", absence: "never",
    coachColumn: null, requiredBy: null,
    decodeSubstitute: "nil", wrongByDefault: false,
    collectedBy: null, readBy: [] },
  { column: "stall_rate", property: "stallRate", need: "displayOnly", absence: "never",
    coachColumn: null, requiredBy: null,
    decodeSubstitute: "nil", wrongByDefault: false,
    collectedBy: null, readBy: [] },
  { column: "sample_size", property: "sampleSize", need: "displayOnly", absence: "never",
    coachColumn: null, requiredBy: null,
    decodeSubstitute: "0", wrongByDefault: false,
    collectedBy: null, readBy: [] },
  { column: "last_reviewed_by_admin", property: "lastReviewedByAdmin", need: "displayOnly", absence: "never",
    coachColumn: null, requiredBy: null,
    decodeSubstitute: "nil", wrongByDefault: false,
    collectedBy: null, readBy: [] },
  { column: "review_status", property: "reviewStatus", need: "fetchGate", absence: "never",
    coachColumn: null, requiredBy: "HybridTrainer/Services/AI/ExerciseFilterService.swift",
    decodeSubstitute: ".published", wrongByDefault: false,
    collectedBy: null, readBy: ["ExerciseFilterService.swift", "ProgramValidator.swift"] },
  { column: "ai_review_verdict", property: "aiReviewVerdict", need: "displayOnly", absence: "never",
    coachColumn: null, requiredBy: null,
    decodeSubstitute: "nil", wrongByDefault: false,
    collectedBy: null, readBy: [] },
  { column: "ai_review_reason", property: "aiReviewReason", need: "displayOnly", absence: "never",
    coachColumn: null, requiredBy: null,
    decodeSubstitute: "nil", wrongByDefault: false,
    collectedBy: null, readBy: [] },
  { column: "ai_reviewed_at", property: "aiReviewedAt", need: "displayOnly", absence: "never",
    coachColumn: null, requiredBy: null,
    decodeSubstitute: "nil", wrongByDefault: false,
    collectedBy: null, readBy: [] },
  { column: "ingestion_source_id", property: "ingestionSourceId", need: "displayOnly", absence: "never",
    coachColumn: null, requiredBy: null,
    decodeSubstitute: "nil", wrongByDefault: false,
    collectedBy: null, readBy: [] },
];

/** The fields a coach row must carry before the engine may seat it (§3.1), in column order. */
export const ENGINE_REQUIRED_FIELDS: readonly EngineField[] = ENGINE_FIELDS.filter(
  (f) => f.need === "required" || f.need === "requiredForMobility",
);

/** Required columns no builder pair (web AND phone) collects today — the coach-side gap §7 step 3 closes. */
export const ENGINE_COACH_GAP: readonly string[] = ["exercise_type", "is_hold", "movement_pattern_id", "injury_contraindications", "goals_served", "mobility_drill_kind"];

/** The satellite no column carries: exercise_coverage rows (the joint-action ledger, keyed by exercise NAME; an undescribed row counts toward no cell and the week reads provisional). */
export const ENGINE_COVERAGE_SATELLITE = "exercise_coverage";

function isEmptyValue(v: unknown): boolean {
  if (Array.isArray(v)) return v.length === 0;
  if (typeof v === "string") return v.trim() === "";
  if (v !== null && typeof v === "object") return Object.keys(v as object).length === 0;
  return false;
}

/** The columns ABSENT on a RAW row (an object as the database returns it), by the rule in the header. */
export function engineAbsentFields(row: Record<string, unknown>): string[] {
  const category = typeof row.category === "string" ? row.category.toLowerCase() : "";
  const isMobility = category.includes("mobil");
  const out: string[] = [];
  for (const f of ENGINE_FIELDS) {
    if (f.absence === "never") continue;
    const v = row[f.column];
    const isNull = v === undefined || v === null;
    if (f.absence === "nullOnly" && isNull) out.push(f.column);
    else if (f.absence === "nullOrEmpty" && (isNull || isEmptyValue(v))) out.push(f.column);
    else if (f.absence === "mobilityOnly" && isMobility && isNull) out.push(f.column);
  }
  return out;
}
